import { render, staticRenderFns } from "./Group.tab.vue?vue&type=template&id=2c4d4e12&"
import script from "./Group.tab.vue?vue&type=script&lang=ts&"
export * from "./Group.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports